/* tslint:disable */
import {
  Emoji,
  GamePlayer
} from '../index';

declare var Object: any;
export interface GamePlayerEmojiInterface {
  "gamePlayerId"?: any;
  "emojiId"?: any;
  "position"?: number;
  "id"?: any;
  emoji?: Emoji;
  player?: GamePlayer;
}

export class GamePlayerEmoji implements GamePlayerEmojiInterface {
  "gamePlayerId": any;
  "emojiId": any;
  "position": number;
  "id": any;
  emoji: Emoji;
  player: GamePlayer;
  constructor(data?: GamePlayerEmojiInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `GamePlayerEmoji`.
   */
  public static getModelName() {
    return "GamePlayerEmoji";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of GamePlayerEmoji for dynamic purposes.
  **/
  public static factory(data: GamePlayerEmojiInterface): GamePlayerEmoji{
    return new GamePlayerEmoji(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'GamePlayerEmoji',
      plural: 'game-player-emojis',
      path: 'game-player-emojis',
      idName: 'id',
      properties: {
        "gamePlayerId": {
          name: 'gamePlayerId',
          type: 'any'
        },
        "emojiId": {
          name: 'emojiId',
          type: 'any'
        },
        "position": {
          name: 'position',
          type: 'number',
          default: 1
        },
        "id": {
          name: 'id',
          type: 'any'
        },
      },
      relations: {
        emoji: {
          name: 'emoji',
          type: 'Emoji',
          model: 'Emoji',
          relationType: 'belongsTo',
                  keyFrom: 'emojiId',
          keyTo: 'id'
        },
        player: {
          name: 'player',
          type: 'GamePlayer',
          model: 'GamePlayer',
          relationType: 'belongsTo',
                  keyFrom: 'gamePlayerId',
          keyTo: 'id'
        },
      }
    }
  }
}
